import { inject, Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { FormatService } from './format.service';
import { LanguageService } from './language.service';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  private readonly formatService = inject(FormatService);
  private readonly languageService = inject(LanguageService);
  private readonly utilityService = inject(UtilityService);

  ngbDateFromString(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1 && this.utilityService.isNumber(dateParts[0])) {
        return { year: undefined, month: undefined, day: this.utilityService.toInteger(dateParts[0]) };
      } else if (
        dateParts.length === 2 &&
        this.utilityService.isNumber(dateParts[0]) &&
        this.utilityService.isNumber(dateParts[1])
      ) {
        return {
          year: undefined,
          month: this.utilityService.toInteger(this.languageService.isUS ? dateParts[0] : dateParts[1]),
          day: this.utilityService.toInteger(this.languageService.isUS ? dateParts[1] : dateParts[0]),
        };
      } else if (
        dateParts.length === 3 &&
        this.utilityService.isNumber(dateParts[0]) &&
        this.utilityService.isNumber(dateParts[1]) &&
        this.utilityService.isNumber(dateParts[2])
      ) {
        let year = this.utilityService.toInteger(dateParts[2]);
        if (year < 100) {
          year += 2000;
        }
        return {
          year: year,
          month: this.utilityService.toInteger(this.languageService.isUS ? dateParts[0] : dateParts[1]),
          day: this.utilityService.toInteger(this.languageService.isUS ? dateParts[1] : dateParts[0]),
        };
      }
    }
    return undefined;
  }

  stringFromNgbDate(date: NgbDateStruct): string {
    const formattedDate = this.dateFromNgbDate(date);
    return formattedDate ? this.formatService.date(formattedDate) : '';
  }

  dateFromStringOrDate(dateString: string | Date): Date {
    if (!dateString) {
      return undefined;
    }

    if (dateString instanceof Date) {
      return dateString;
    }

    return this.dateFromString(dateString);
  }

  dateFromNgbDate(date: NgbDateStruct): Date {
    if (!date) {
      return undefined;
    }
    return new Date(Date.UTC(date.year, date.month - 1, date.day));
  }

  dateFromString(date: string): Date {
    return this.dateFromNgbDate(this.ngbDateFromString(date));
  }
}
